import { EInsightsIASeverity } from "../@types/InsightsEnuns";
import { TAnaliseInsight } from "../views/agenteDeDRE/services/InsightsAIDreGateway";
import {
  EInsightsIAAnalysisType,
  type IInsightsIAAnalysisOption
} from "../views/agenteDeDRE/types";

export const insightsIAAnalysisOptions: IInsightsIAAnalysisOption[] = [
  {
    label: "Análise vertical",
    value: EInsightsIAAnalysisType.Vertical
  },
  {
    label: "Análise horizontal",
    value: EInsightsIAAnalysisType.Horizontal,
    tag: "Em breve",
    disabled: true
  }
];

export const insightsIAMock: TAnaliseInsight[] = [
  {
    id: "1",
    order: 1,
    title: "Queda de 12% na Receita Bruta em Marco",
    severity: EInsightsIASeverity.Critical,
    usefulInsight: null,
    summary:
      "A Receita Bruta de marco foi de R$ 1.284.500, representando uma queda de 12% em relacao a fevereiro e 8% abaixo da media dos ultimos 6 meses.",
    riskDescription:
      "Manter o patamar atual comprime a margem bruta em aproximadamente R$ 160k/mes. Em 6 meses, o impacto acumulado pode inviabilizar o plano de expansao previsto para o 4o tri.",
    suggestedActions: [
      "Renegociar contratos com os 3 maiores fornecedores de materia-prima",
      "Revisar ficha tecnica dos produtos com maior giro (SKUs A)",
      "Implementar inventario ciclico semanal para reduzir perdas"
    ]
  },
  {
    id: "2",
    order: 2,
    title: "Aumento relevante em despesas operacionais",
    severity: EInsightsIASeverity.Critical,
    usefulInsight: true,
    summary:
      "As despesas operacionais cresceram 18% contra a media recente, puxadas principalmente por servicos de terceiros e manutencao. As despesas operacionais cresceram 18% contra a media recente, puxadas principalmente por servicos de terceiros e manutencao. As despesas operacionais cresceram 18% contra a media recente, puxadas principalmente por servicos de terceiros e manutencao.",
    riskDescription:
      "Sem acao corretiva, o aumento pode reduzir a margem EBITDA e comprometer o fluxo de caixa dos proximos periodos.",
    suggestedActions: [
      "Revisar contratos de servicos recorrentes",
      "Separar despesas pontuais de despesas recorrentes",
      "Definir teto mensal para categorias com maior variacao"
    ]
  },
  {
    id: "3",
    order: 3,
    title: "Margem bruta abaixo do patamar esperado",
    severity: EInsightsIASeverity.Warning,
    usefulInsight: true,
    summary:
      "A margem bruta ficou 3,4 pontos percentuais abaixo do objetivo definido para o periodo, mesmo com volume de vendas estavel.",
    riskDescription:
      "A variacao pode estar ligada a aumento de custos diretos, descontos comerciais ou mudanca no mix de produtos.",
    suggestedActions: [
      "Comparar margem por familia de produto",
      "Revisar descontos aplicados no periodo",
      "Avaliar reajuste em produtos com margem negativa"
    ]
  },
  {
    id: "4",
    order: 4,
    title: "Crescimento de despesas administrativas",
    severity: EInsightsIASeverity.Warning,
    usefulInsight: true,
    summary:
      "As despesas administrativas subiram 9% no mes, acima do crescimento da receita e do comportamento historico do grupo.",
    riskDescription:
      "O crescimento recorrente pode reduzir previsibilidade do resultado e exige revisao das categorias com maior variacao.",
    suggestedActions: [
      "Listar categorias administrativas com maior aumento",
      "Validar despesas fora do orcamento previsto",
      "Criar acompanhamento semanal das categorias criticas"
    ]
  },
  {
    id: "5",
    order: 5,
    title: "Resultado financeiro consumindo margem",
    severity: EInsightsIASeverity.Warning,
    usefulInsight: true,
    summary:
      "Encargos financeiros e tarifas aumentaram 6%, reduzindo o ganho operacional antes do resultado liquido.",
    riskDescription:
      "Acompanhar taxas, tarifas e renegociacoes pode evitar que o efeito financeiro esconda ganhos operacionais.",
    suggestedActions: [
      "Conferir tarifas bancarias e encargos recorrentes",
      "Renegociar taxas com instituicoes financeiras",
      "Simular impacto de antecipacoes no resultado financeiro"
    ]
  }
];
